import { BaseRepository } from "@/repositories/base-repository"
import { type IFileRelation } from "@/interfaces/api/file-relation.interface"

export class FileRelationRepository extends BaseRepository<IFileRelation> {
  protected resourcePath = "core/file-relations"
}
